// Feature permission keys — must stay in sync with
// dashboard-api/src/services/permissions/permissions.constants.ts
export const FEATURES = [
  "catalog",
  "ai_tools",
  "analytics",
  "api_keys",
  "billing",
  "support",
  "team",
] as const;

export type FeatureKey = (typeof FEATURES)[number];

export type FeaturePermissions = Record<FeatureKey, boolean>;

export type OrganizationRole = "owner" | "admin" | "member";

export const FEATURE_LABELS: Record<FeatureKey, { label: string; description: string }> = {
  catalog: {
    label: "Product Catalog",
    description: "Catalogues, categories, products, moderation and reviews",
  },
  ai_tools: {
    label: "AI Tools",
    description: "Lens, visualizers, swap, magic background and 2D-to-3D",
  },
  analytics: {
    label: "Analytics",
    description: "Usage statistics, analytics and activity feeds",
  },
  api_keys: {
    label: "API Keys",
    description: "Create and manage API keys in the Integration Hub",
  },
  billing: {
    label: "Billing",
    description: "Subscription, plans and invoices",
  },
  support: {
    label: "Support",
    description: "Create and view support tickets",
  },
  team: {
    label: "Team",
    description: "View organization members and invitations",
  },
};

export const ROLE_LABELS: Record<OrganizationRole, string> = {
  owner: "Owner",
  admin: "Admin",
  member: "Member",
};
